module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/1/1-d008fba4506adda703bb286776df8ea2.jpg";